
import List from './List.vue'
import ManageSpecialOfferRoute from '@/views/SpecialOffer/ManageSpecialOffer/router'

export default [
  {
    path: 'list',
    name: 'SpecialOfferList',
    component: List
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "special-offer" */ '@/views/SpecialOffer/ManageSpecialOffer/Index.vue'),
    children: ManageSpecialOfferRoute
  }
]
